import cn from 'classnames';
import { FC, RefObject } from 'react';

import './GDPRBanner.css';
import { useStory3CookieLinks } from 'contexts/GDPRContext/customizeGDPRBanner';
import { usePartnerRouterContext } from 'contexts/PartnerRouter/usePartnerRouterContext';

type GDPRBannerProps = {
    bannerRef: RefObject<HTMLDivElement>;
    isLoaded: boolean;
};

export const GDPRBanner: FC<GDPRBannerProps> = ({ isLoaded, bannerRef }) => {
    const { getRoute } = usePartnerRouterContext();
    useStory3CookieLinks(getRoute);

    return (
        <div
            id="gdpr-consent-form"
            ref={bannerRef}
            className={cn([!isLoaded && 'story3_gdpr_banner_hidden'])}
        />
    );
};
